import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    launchRatingJob as launchRatingJobApi,
    getRatingJobStatus as getRatingJobStatusApi,
    stopRatingJob as stopRatingJobApi,
    restartRatingJob as restartRatingJobApi,
    getAllRatingJobs as getAllRatingJobsApi,
} from '../../helpers';
import {
    ratingJobsApiResponseSuccess,
    ratingJobsApiResponseError,
} from './actions';
import { RatingJobsActionTypes } from './constants';
import { addToast } from '../actions';
import { ratingJobResponseToRatingJobObject } from '../../helpers/mappers/rating-job';
export function* launchRatingJob({ payload: { integrationId } }) {
    try {
        yield put(addToast({ desc: 'Starting rating job', type: 'success' }));
        const launchRatingJobResponse = yield call(launchRatingJobApi, integrationId);
        yield put(addToast({ desc: 'Rating job completed', type: 'success' }));
        yield put(ratingJobsApiResponseSuccess(RatingJobsActionTypes.LAUNCH_RATING_JOB, null));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(ratingJobsApiResponseError(RatingJobsActionTypes.LAUNCH_RATING_JOB, error));
    }
}

export function* getRatingJobStatus({ payload: { integrationId } }) {
    try {
        const ratingJobStatus = yield call(getRatingJobStatusApi, integrationId);
        yield put(ratingJobsApiResponseSuccess(RatingJobsActionTypes.GET_RATING_JOB_STATUS, ratingJobStatus));
    } catch (error) {
        yield put(ratingJobsApiResponseError(RatingJobsActionTypes.GET_RATING_JOB_STATUS, error));
    }
}

export function* stopRatingJob({ payload: { integrationId } }) {
    try {
        const stopRatingJobResponse = yield call(stopRatingJobApi, integrationId);
        yield put(ratingJobsApiResponseSuccess(RatingJobsActionTypes.STOP_RATING_JOB, null));
    } catch (error) {
        yield put(ratingJobsApiResponseError(RatingJobsActionTypes.STOP_RATING_JOB, error));
    }
}

export function* restartRatingJob({ payload: { integrationId } }) {
    try {
        const restartRatingJobResponse = yield call(restartRatingJobApi, integrationId);
        yield put(ratingJobsApiResponseSuccess(RatingJobsActionTypes.RESTART_RATING_JOB, null));
    } catch (error) {
        yield put(ratingJobsApiResponseError(RatingJobsActionTypes.RESTART_RATING_JOB, error));
    }
}

export function* getAllRatingJobs() {
    try {
        const getAllRatingJobsResponse = yield call(getAllRatingJobsApi);
        const ratingJobs = getAllRatingJobsResponse.data.map((ratingJob) => 
            ratingJobResponseToRatingJobObject(ratingJob)
        );
        yield put(ratingJobsApiResponseSuccess(RatingJobsActionTypes.GET_ALL_RATING_JOBS, ratingJobs));
    } catch (error) {
        yield put(ratingJobsApiResponseError(RatingJobsActionTypes.GET_ALL_RATING_JOBS, error));
    }
}

export function* watchLaunchRatingJobSaga() {
    yield takeLatest(RatingJobsActionTypes.LAUNCH_RATING_JOB, launchRatingJob);
}

export function* watchGetRatingJobStatusSaga() {
    yield takeLatest(RatingJobsActionTypes.GET_RATING_JOB_STATUS, getRatingJobStatus);
}

export function* watchStopRatingJobSaga() {
    yield takeLatest(RatingJobsActionTypes.STOP_RATING_JOB, stopRatingJob);
}

export function* watchRestartRatingJobSaga() {
    yield takeLatest(RatingJobsActionTypes.RESTART_RATING_JOB, restartRatingJob);
}

export function* watchGetAllRatingJobsSaga() {
    yield takeLatest(RatingJobsActionTypes.GET_ALL_RATING_JOBS, getAllRatingJobs);
}

function* ratingJobsSaga() {
    yield all([
        fork(watchLaunchRatingJobSaga),
        fork(watchGetRatingJobStatusSaga),
        fork(watchStopRatingJobSaga),
        fork(watchRestartRatingJobSaga),
        fork(watchGetAllRatingJobsSaga),
    ]);
}

export default ratingJobsSaga;
